/**
 * @description header1 button menu
 * @author wangfupeng
 */

import HeaderButtonMenuBase from './HeaderButtonMenuBase'

class Header1ButtonMenu extends HeaderButtonMenuBase {
  title = 'H1'
  type = 'header1'
}

export default Header1ButtonMenu
